import { useState } from 'react';
import api from '@/utils/api';
import { SummarizerApiResponse } from '../types';

export const useSummarizer = () => {
    const [websiteUrl, setWebsiteUrl] = useState('');
    const [summary, setSummary] = useState<SummarizerApiResponse | null>(null);
    const [isSummarizing, setIsSummarizing] = useState(false);
    const [summaryError, setSummaryError] = useState('');

    const handleSummarize = async () => {
        if (!websiteUrl.trim()) {
            setSummaryError('Please enter a valid email or website URL.');
            return;
        }

        setSummaryError('');
        setIsSummarizing(true);
        setSummary(null);

        try {
            const { data } = await api.post('/builder/summarize', {
                email: websiteUrl,
                website: websiteUrl,
            });
            setSummary(data as SummarizerApiResponse);
        } catch (err) {
            console.error('Summarizer API error:', err);
            setSummaryError('Failed to fetch summary. Please try again.');
        } finally {
            setIsSummarizing(false);
        }
    };

    const safeParseSummaryText = (s?: string) => {
        if (!s) return '';
        try {
            const o = JSON.parse(s);
            if (o && typeof o.summary === 'string') return o.summary.trim();
        } catch { }
        return s;
    };

    return {
        websiteUrl,
        setWebsiteUrl,
        summary,
        isSummarizing,
        summaryError,
        handleSummarize,
        safeParseSummaryText
    };
};
